// LoginPage.tsx

import { useEffect } from "react";
import { Grid, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LoginIntro } from "@/components/LoginIntro";
import { AuthForm } from "@/components/AuthForm";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { useAuthStore } from "@/store/useAuthStore";

export default function LoginPage() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const navigate = useAppNavigate();
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const { t } = useTranslation("translation", { keyPrefix: "pages.login" });

  useEffect(() => {
    // Only navigate after Firebase + /auth/me finished loading
    if (!isLoading && isAuthenticated) {
      // Navigate to main detail or dashboard page
      navigate(`/`);
      // Or user specific page: navigate(`/profile/${user?.userId}`);
    }
  }, [isAuthenticated, isLoading, user, navigate]);

  return (
    <Grid container aria-label={t("title")} sx={{ minHeight: "100vh" }}>
      {/* LEFT COLUMN: Feature Showcase & Compliance Hub Content */}
      <Grid
        size={{ xs: 12, md: 6, lg: 7 }}
        sx={{
          background: `linear-gradient(135deg, ${isDark ? theme.palette.background.paper : "#0F172A"} 0%, ${
            isDark ? theme.palette.background.default : "#1E293B"
          } 50%, ${theme.palette.primary.dark} 100%)`,
          color: "common.white",
          p: { xs: 4, sm: 6, md: 8 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <LoginIntro />
      </Grid>

      {/* RIGHT COLUMN: Form Container */}
      <Grid
        size={{ xs: 12, md: 6, lg: 5 }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
          p: { xs: 3, sm: 6 },
        }}
      >
        <AuthForm />
      </Grid>
    </Grid>
  );
}
